<template>
  <div class="">
 

    <nav class="navbar navbar-expand-lg navbar-light bg-light" style="max-height: 120px" >
      <div class="col-md-6">
        <router-link class="navbar-brand text-center nav-item" style="margin-left: 50%" :to="{name: 'Index'}">
        </router-link>
      </div>
      <div class="col-md-6">
        <div class="navbar-nav">
          <div class="nav-item nav-side">
            <a class="navbar-brand box-content text-center" href="#">
          
            </a>
          </div>
          <div class="nav-item nav-side-right"> <router-link :to="{name: 'SupportUs'}"><h4 style="margin-top: 70%">Support Us</h4></router-link></div>
           <div class="nav-item nav-side-right"> <router-link :to="{name: 'VolunteerProgram'}"><h4 style="margin-top: 40%">Immersive Conservation Experiences Programme </h4></router-link></div>
          <div class="nav-item nav-side-right"> <router-link :to="{name: 'RegisterMember'}"><h4 style="margin-top: 40%"> Become a Member </h4></router-link></div>
          <div class="nav-item nav-side-right"> <router-link :to="{name: 'Login'}"><h4 style="margin-top: 130%"> Login </h4></router-link></div>
          <div class="nav-item nav-side-right"> <router-link :to="{name: 'Login'}"><h4 style="margin-top: 130%"> Login </h4></router-link></div>
         
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'main-nav',
  data () {
    return {
      route: this.$route.name
    }
  },
  methods: {
    clearData: function () {
      localStorage.removeItem('current_booking')
      localStorage.removeItem('current_express_booking')
    }
  },
  mixins: []
}
</script>

<style scoped="PublicNav">
  .nav-side {
    /*padding-bottom: 1%;*/
    /*padding-top: 1%;*/
    padding-left: -2%;
    padding-right: -2%;
    border-left: 1px solid lightgray;
    border-right: 1px solid lightgray;
  }
  .nav-side-right {
    min-width: 20px;
    /*padding-bottom: 1%;*/
    /*padding-top: 1%;*/
    padding-left: 10px;
    padding-right: 10px;
    border-right: 1px solid lightgray;
  }

  .menu-item {
    margin-left: 1%;
    margin-right: 1%;
    margin-top: 5%;
    margin-bottom: 5%;
  }
  h6 {
    color: #73a533;
    font-size: 70%;
  }
  a {
    text-decoration: none;
  }

</style>
